import { PRODUCT_TABS, ProductTabKey } from './productTabConfig';
import './ProductTabBar.css';

interface ProductTabBarProps {
  activeTab: ProductTabKey;
  onChange: (tab: ProductTabKey) => void;
  /** 아직 열 수 없는 탭 (등록 직 등) */
  lockedTabs?: ProductTabKey[];
}

function ProductTabBar({ activeTab, onChange, lockedTabs = [] }: ProductTabBarProps) {
  return (
    <div className="product-tabs" role="tablist" aria-label="제품 상세 탭">
      {PRODUCT_TABS.map((tab) => {
        const locked = lockedTabs.includes(tab.key);
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`product-tabs__item${activeTab === tab.key ? ' is-active' : ''}${
              locked ? ' is-locked' : ''
            }`}
            disabled={locked}
            title={locked ? '제품을 먼저 저장해 주세요.' : undefined}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default ProductTabBar;
